import React, { FC } from 'react';
import { useTitle } from '../../hooks/useTitle';
import { PATH_NAME } from '../../store/slices/Navigation/reducer';
import { SurveyToolbar } from './SurveyToolbar';

export const Toolbar: FC = () => {
  const path = useTitle();

  switch (path) {
    case PATH_NAME.HOME:
      return <SurveyToolbar />;
    case PATH_NAME.SURVEYS:
      return <SurveyToolbar />;
    default:
      return null;
  };
};
